class deleteSeatplan {
    constructor(Alert, $http, $state, $stateParams) {

        this.key = 'delete-seatplan';
        this.title = 'Delete';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.back = $stateParams.back;
        this.params = $stateParams.backParams || {
            id: $stateParams.id
        };
    }

    action(seatplan, vm) {
        this.alert.confirm({
            title: `Deleting ${ seatplan.title}`,
            message: 'Are you sure you want to delete this seatplan? This cannot be undone!',
            confirmBtn: 'Delete'
        }).then(() => {
            return this.api.delete(`seatplans/${ seatplan.id }`, {data: {force: true}})
                .then(() => {
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.seatplans')
    .factory('deleteSeatplan', [
        'Alert',
        '$http',
        '$state',
        '$stateParams',
        (Alert, $http, $state, $stateParams) => new deleteSeatplan(Alert, $http, $state, $stateParams)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/seatplans/workflows/delete-seatplan.js